import { FunctionComponent } from 'react';
import { useFormikContext } from 'formik';
import { useDirtyGuard } from '@starjack/shared-components';

/** Reports Formik's `dirty` to the surrounding FormDrawer. Render inside `<Formik>`. */
export const FormikDirtyGuard: FunctionComponent = () => {
    useDirtyGuard(useFormikContext().dirty);
    return null;
};
